let isPlaywrightTestBuildTime = false;
// #if process.env.PLAYWRIGHT_TEST === 'true'
// isPlaywrightTestBuildTime = true;
// #endif
const isPlaywrightTestRuntime = typeof process !== 'undefined' && process.env?.PLAYWRIGHT_TEST === 'true';

const ENVIRONMENT_FLAGS = {
  isPlaywrightTest: isPlaywrightTestBuildTime || isPlaywrightTestRuntime,
};

export const ENVIRONMENT_CONFIG = {
  /**
   * Whether promotional campaigns and time-sensitive notifications are disabled
   * - Regular app: false (campaigns are enabled)
   * - Test environments: true (campaigns are disabled for predictable testing)
   */
  arePromotionalCampaignsDisabled: ENVIRONMENT_FLAGS.isPlaywrightTest,
  http: {
    /**
     * Maximum number of retry attempts for HTTP requests
     * - Regular app: 10 retries
     * - Playwright tests: 1 retry (reduced for faster test execution)
     */
    maxRetries: ENVIRONMENT_FLAGS.isPlaywrightTest ? 1 : 10,
    /**
     * Maximum wait time for HTTP requests
     * - Regular app: 4000ms
     * - Playwright tests: 1000ms (reduced for faster test execution)
     */
    maxWaitTime: ENVIRONMENT_FLAGS.isPlaywrightTest ? 1000 : 4000,
  },
};

export enum EnvironmentType {
  Labs = 'labs',
  Staging = 'staging',
  Production = 'production',
}
